import { showError } from "./ErrorPopup";
import React, { useState } from 'react';
import { apiFetch } from '../utils/apiClient'; // ✅ import your reusable fetch hel

function FichierExcel() {
    const [loading, setLoading] = useState(false);
    const handleDownload = async () => {
  try {
    setLoading(true); // commence le loading
    const response = await apiFetch( `${process.env.REACT_APP_API_BASE_URL}/downloadExcel`, {
      method: 'POST',
    });
    
    if (!response.ok) {
      let message = "Erreur lors de la génération des fichiers Excel.";

      try {
        const result = await response.json();
        message = result.error || result.message || message;
      } catch {
        // La réponse d'erreur n'est pas nécessairement au format JSON.
      }

      throw new Error(message);
    }

    const blob = await response.blob();

      // Parse filename from Content-Disposition header
      const disposition = response.headers.get('Content-Disposition');
      let filename = 'Export-batch.zip'; // fallback filename

      if (disposition && disposition.includes('filename=')) {
        filename = disposition
          .split('filename=')[1]
          .trim()
          .replace(/"/g, '');
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename); // use filename from header here
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    
  } catch (error) {
      console.error(error);
      showError(error); // ou setError(error.message)
    }finally {
      setLoading(false); // termine le loading
    }
};
      return (
    <div>
      <button
        onClick={handleDownload}
        disabled={loading} // désactive le bouton pendant le téléchargement
        className={`text-sm px-6 py-2 font-semibold rounded-lg shadow-md transition duration-200
          ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400'}`}
      >
        {loading ? 'Téléchargement en cours...' : 'Télécharger les fichiers Excel'}
      </button>
    </div>
  );
}

export default FichierExcel
